import DOMPurify from "isomorphic-dompurify";

/**
 * Sanitizuj HTML iz CMS/PIM izvora pre renderovanja kroz dangerouslySetInnerHTML.
 * Blokira <script>, on* event handlere, javascript: URL-ove i druge XSS vektore.
 * Takođe uklanja prazne paragrafe / linkove / wrappere koji ostaju iza legacy CMS
 * sadržaja (npr. banner placeholderi sa <img src="">), kako ne bi pravili prazan
 * prostor na dnu kategorija.
 */
let hookInstalled = false;
function ensureHook() {
  if (hookInstalled) return;
  hookInstalled = true;
  DOMPurify.addHook("afterSanitizeAttributes", (node: any) => {
    if (node?.tagName === "A" && node.getAttribute) {
      const href = node.getAttribute("href") || "";
      const isExternal = /^(https?:)?\/\//i.test(href) && !/(^|\.)kerametal\.(rs|app)(\/|$|:)/i.test(href);
      if (isExternal) {
        node.setAttribute("rel", "nofollow noopener noreferrer");
        if (!node.getAttribute("target")) node.setAttribute("target", "_blank");
      }
    }
  });
}

export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return "";
  ensureHook();
  const clean = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ["target", "rel", "id", "data-product-sku"],
  });
  return stripEmpty(clean);
}

function stripEmpty(html: string): string {
  let s = html;
  // Ukloni <img> bez src ili sa praznim src
  s = s.replace(/<img\b[^>]*\bsrc\s*=\s*(?:""|'')[^>]*\/?>/gi, "");
  s = s.replace(/<img\b(?![^>]*\bsrc=)[^>]*\/?>/gi, "");

  // Iterativno čisti prazne wrappere (anchor/span/p/div/strong/em/b/i)
  const emptyTag = /<(a|span|p|div|strong|em|b|i)\b[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/\1>/gi;
  let prev: string;
  do {
    prev = s;
    s = s.replace(emptyTag, "");
  } while (s !== prev);

  return s.trim();
}
